// extracted by mini-css-extract-plugin
export default {"cartItemQuantity":"cartItemQuantity__YzQyZ","smaller":"smaller__OGI2N"};